import React, { useState } from 'react';
import { Button } from '../components/Button';
import { PhoneIcon, MessageSquareIcon, ClockIcon, CalendarIcon, HelpCircleIcon, BellIcon, CheckIcon, PhoneForwardedIcon, MessageCircleIcon, CalendarCheckIcon, ZapIcon, WorkflowIcon, DatabaseIcon, BrainCircuitIcon, StarIcon, QuoteIcon, ChevronDownIcon } from 'lucide-react';
function HeroLight() {
  return <section className="w-full bg-white text-[#1A1A1A] py-28 md:py-40 lg:py-48 relative overflow-hidden" data-id="element-1559">
      {/* Background Image with Gradient Mask */}
      <div className="absolute inset-0" data-id="element-1560">
        <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=1920&q=80" alt="" className="w-full h-full object-cover" data-id="element-1561" />
        {/* Gradient overlay: bottom 100%, middle (85%) 80%, top 20% */}
        <div className="absolute inset-0 bg-gradient-to-t from-white via-white/80 via-85% to-white/20" data-id="element-1562"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center relative z-10" data-id="element-1563">
        <h1 className="font-['Poppins'] font-bold text-4xl md:text-6xl lg:text-7xl leading-[1.15] mb-8 tracking-tight text-[#1A1A1A]" data-id="element-1564">
          Your 24/7 AI Answering Service That Grows Your Business
        </h1>
        <p className="font-['Inter'] text-lg md:text-xl lg:text-2xl text-[#6B6B6B] max-w-4xl mx-auto mb-12 leading-relaxed font-light" data-id="element-1565">
          Instant call pickup, professional message capture, and a fully branded
          AI agent designed to improve customer satisfaction and support your
          business around the clock.
        </p>
        <Button size="lg" data-id="element-1566">Start Free 7-Day Trial</Button>
      </div>
    </section>;
}
function ValuePropositionLight() {
  const benefits = [{
    icon: ClockIcon,
    title: '24/7 Instant Call Answering',
    description: 'Never miss a call again with round-the-clock AI coverage that picks up instantly'
  }, {
    icon: MessageSquareIcon,
    title: 'Customised Company Greeting',
    description: 'Fully branded experience that sounds like your business, not a generic service'
  }, {
    icon: PhoneIcon,
    title: 'Accurate Capture',
    description: 'Precise name, number, and message recording with intelligent transcription'
  }, {
    icon: BellIcon,
    title: 'Real-Time Call Summaries',
    description: 'Instant notifications with complete call context delivered immediately'
  }, {
    icon: HelpCircleIcon,
    title: 'FAQ Handling',
    description: 'Answer common questions with fenced, brand-safe responses automatically'
  }, {
    icon: CalendarIcon,
    title: 'Appointment Booking',
    description: 'Seamless calendar integration for automated scheduling and confirmations'
  }];
  return <section className="w-full bg-[#F5F5F5] py-28 md:py-36" data-id="element-1567">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1568">
        <div className="text-center mb-20" data-id="element-1569">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl text-[#1A1A1A] mb-6 tracking-tight" data-id="element-1570">
            Why Choose Our AI Answering Service?
          </h2>
          <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B]" data-id="element-1571">
            Your Always-On Receptionist, without the overheads
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1572">
          {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return <div key={index} className="bg-white rounded-2xl p-10 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md" data-id="element-1573">
                <div className="w-14 h-14 bg-[#F1B530]/10 rounded-xl flex items-center justify-center mb-6 border border-[#F1B530]/20" data-id="element-1574">
                  <Icon className="w-7 h-7 text-[#F1B530]" data-id="element-1575" />
                </div>
                <h3 className="font-['Inter'] font-semibold text-xl text-[#1A1A1A] mb-4" data-id="element-1576">
                  {benefit.title}
                </h3>
                <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-1577">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function FeatureShowcaseLight() {
  return <section className="w-full bg-white py-28 md:py-36" data-id="element-1578">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1579">
        {/* Feature 1 - Left Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-32" data-id="element-1580">
          <div className="relative" data-id="element-1581">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-[#E5E5E5] shadow-xl" data-id="element-1582">
              <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&q=80" alt="Real-time dashboard analytics" className="w-full h-full object-cover" data-id="element-1583" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#F1B530] rounded-2xl p-6 shadow-xl" data-id="element-1584">
              <div className="font-['Poppins'] text-4xl font-bold text-white mb-1" data-id="element-1585">
                100%
              </div>
              <div className="font-['Inter'] text-sm text-white font-semibold" data-id="element-1586">
                Capture Rate
              </div>
            </div>
          </div>

          <div data-id="element-1587">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-1588">
              Real-Time Dashboard & Analytics
            </h2>
            <p className="font-['Inter'] text-lg text-[#6B6B6B] mb-8 leading-relaxed font-light" data-id="element-1589">
              Monitor every call in real-time with comprehensive analytics.
              Track call volume, response times, customer satisfaction, and
              conversion rates all in one intuitive dashboard.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1590">
              <li className="flex items-start" data-id="element-1591">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1592">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1593">
                  Live call monitoring and notifications
                </span>
              </li>
              <li className="flex items-start" data-id="element-1594">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1595">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1596">
                  Detailed call transcripts and recordings
                </span>
              </li>
              <li className="flex items-start" data-id="element-1597">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1598">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1599">
                  Performance metrics and insights
                </span>
              </li>
            </ul>
            <Button data-id="element-1600">Explore Dashboard</Button>
          </div>
        </div>

        {/* Feature 2 - Right Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-32" data-id="element-1601">
          <div className="lg:order-2 relative" data-id="element-1602">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-[#E5E5E5] shadow-xl" data-id="element-1603">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=1200&q=80" alt="Seamless integrations" className="w-full h-full object-cover" data-id="element-1604" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white border-2 border-[#F1B530] rounded-2xl p-6 shadow-xl" data-id="element-1605">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-1606">
                50+
              </div>
              <div className="font-['Inter'] text-sm text-[#1A1A1A] font-semibold" data-id="element-1607">
                Integrations
              </div>
            </div>
          </div>

          <div className="lg:order-1" data-id="element-1608">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-1609">
              Seamless CRM & Tool Integration
            </h2>
            <p className="font-['Inter'] text-lg text-[#6B6B6B] mb-8 leading-relaxed font-light" data-id="element-1610">
              Connect with your existing tools effortlessly. Our AI integrates
              with popular CRMs, calendars, and business tools to keep your
              workflow smooth and data synchronized.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1611">
              <li className="flex items-start" data-id="element-1612">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1613">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1614">
                  Salesforce, HubSpot, Zoho CRM
                </span>
              </li>
              <li className="flex items-start" data-id="element-1615">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1616">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1617">
                  Google Calendar, Outlook, Calendly
                </span>
              </li>
              <li className="flex items-start" data-id="element-1618">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1619">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1620">
                  Slack, Teams, Zapier, and more
                </span>
              </li>
            </ul>
            <Button data-id="element-1621">View All Integrations</Button>
          </div>
        </div>

        {/* Feature 3 - Left Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-1622">
          <div className="relative" data-id="element-1623">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden border border-[#E5E5E5] shadow-xl" data-id="element-1624">
              <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&q=80" alt="AI training and customization" className="w-full h-full object-cover" data-id="element-1625" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white border-2 border-[#F1B530] rounded-2xl p-6 shadow-xl" data-id="element-1626">
              <div className="font-['Poppins'] text-4xl font-bold text-[#F1B530] mb-1" data-id="element-1627">
                &lt;5min
              </div>
              <div className="font-['Inter'] text-sm text-[#1A1A1A] font-semibold" data-id="element-1628">
                Setup Time
              </div>
            </div>
          </div>

          <div data-id="element-1629">
            <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-1630">
              Custom AI Training for Your Business
            </h2>
            <p className="font-['Inter'] text-lg text-[#6B6B6B] mb-8 leading-relaxed font-light" data-id="element-1631">
              Train your AI receptionist with your business knowledge, FAQs, and
              specific protocols. The more you customize, the more natural and
              helpful your AI becomes.
            </p>
            <ul className="space-y-4 mb-8" data-id="element-1632">
              <li className="flex items-start" data-id="element-1633">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1634">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1635">
                  Upload FAQs and knowledge base
                </span>
              </li>
              <li className="flex items-start" data-id="element-1636">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1637">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1638">
                  Define custom call routing rules
                </span>
              </li>
              <li className="flex items-start" data-id="element-1639">
                <span className="text-[#F1B530] mr-3 text-xl" data-id="element-1640">•</span>
                <span className="font-['Inter'] text-[#1A1A1A] font-light" data-id="element-1641">
                  Set brand voice and tone guidelines
                </span>
              </li>
            </ul>
            <Button data-id="element-1642">Start Customizing</Button>
          </div>
        </div>
      </div>
    </section>;
}
function IndustryBenefitsLight() {
  const industries = [{
    name: 'Healthcare',
    benefits: ['HIPAA compliant', 'Appointment scheduling', 'Emergency routing', 'Patient messaging']
  }, {
    name: 'Legal',
    benefits: ['Client intake', 'Confidential handling', 'Urgent call screening', 'Case management']
  }, {
    name: 'Real Estate',
    benefits: ['Property inquiries', 'Viewing bookings', 'Lead capture', 'Tenant support']
  }, {
    name: 'Trade Services',
    benefits: ['Job booking', 'Emergency calls', 'Quote requests', 'Service scheduling']
  }, {
    name: 'Retail',
    benefits: ['Order taking', 'Store inquiries', 'Stock checks', 'Customer support']
  }, {
    name: 'Professional Services',
    benefits: ['Client screening', 'Appointment booking', 'Message handling', 'Consultation scheduling']
  }];
  return <section className="w-full bg-[#F5F5F5] py-28" data-id="element-1643">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1644">
        <div className="text-center mb-16" data-id="element-1645">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-1646">
            Trusted Across Industries
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-1647">
            Tailored solutions for every business type
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1648">
          {industries.map((industry, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-1649">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-6" data-id="element-1650">
                {industry.name}
              </h3>
              <ul className="space-y-3" data-id="element-1651">
                {industry.benefits.map((benefit, idx) => <li key={idx} className="font-['Inter'] text-[#6B6B6B] flex items-start" data-id="element-1652">
                    <span className="text-[#F1B530] mr-2" data-id="element-1653">•</span>
                    {benefit}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}
function PricingPlansLight() {
  const plans = [{
    name: 'Scout 25',
    price: 'AUD $65',
    calls: '25 calls/month',
    minutes: '125',
    target: 'Perfect for solo operators testing the waters',
    inclusions: ['Instant call pickup', 'Customised company greeting', 'Name, number & message capture', 'Real-time call summaries via SMS/email', 'Call recordings & transcripts', 'Dashboard analytics', 'Excess: $2.60/call or $0.52/min'],
    ctaText: 'Start 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Forager 50',
    price: 'AUD $115',
    calls: '50 calls/month',
    minutes: '250',
    target: 'Small teams with steady enquiry flow',
    inclusions: ['Everything in Scout 25', 'Priority support', 'Extended call handling', 'Multi-user dashboard access', 'Custom call routing rules', 'Excess: $2.30/call or $0.46/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording',
    isPopular: true
  }, {
    name: 'Drift 75',
    price: 'AUD $165',
    calls: '75 calls/month',
    minutes: '375',
    target: 'Growing teams with rising call peaks',
    inclusions: ['Everything in Forager 50', 'Advanced analytics', 'Team collaboration tools', 'Custom integrations', 'Dedicated account manager', 'Excess: $2.20/call or $0.44/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Surge 150',
    price: 'AUD $325',
    calls: '150 calls/month',
    minutes: '750',
    target: 'High-tempo operations with regular spikes',
    inclusions: ['Everything in Drift 75', 'Priority call routing', 'Advanced workflow automation', 'Custom reporting', 'API access', 'Excess: $2.17/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Swarm 300',
    price: 'AUD $645',
    calls: '300 calls/month',
    minutes: '1,500',
    target: 'Heavy daily call activity teams',
    inclusions: ['Everything in Surge 150', 'Enterprise-grade security', 'Custom AI training', 'White-label options', 'SLA guarantees', 'Excess: $2.15/call or $0.43/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'Colony 500',
    price: 'AUD $955',
    calls: '500 calls/month',
    minutes: '2,250',
    target: 'Enterprise-level high-volume operations',
    inclusions: ['Everything in Swarm 300', 'Dedicated infrastructure', 'Custom AI models', 'Advanced compliance features', '24/7 premium support', 'Excess: $1.91/call or $0.42/min'],
    ctaText: 'Try 7 Day Free Trial',
    ctaLink: 'Listen to call recording'
  }, {
    name: 'AI Automation Customisation',
    target: 'For businesses requiring advanced automation and integrations beyond standard plans',
    inclusions: ['Custom call volumes', 'Bespoke AI training', 'Enterprise integrations', 'Advanced workflow automation', 'Dedicated success team', 'Custom SLAs'],
    ctaText: 'Contact Sales',
    isCustom: true
  }];
  return <section className="w-full bg-[#F5F5F5] py-28 md:py-36" data-id="element-1654">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1655">
        <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] text-center mb-20 tracking-tight" data-id="element-1656">
          Plans
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-1657">
          {plans.slice(0, 6).map((plan, index) => <div key={index} className={`bg-white rounded-2xl p-10 border transition-all duration-300 hover:-translate-y-1 relative flex flex-col h-full shadow-sm hover:shadow-md ${plan.isPopular ? 'border-[#F1B530] shadow-[0_0_40px_rgba(241,181,48,0.15)]' : 'border-[#E5E5E5] hover:border-[#F1B530]/50'}`} data-id="element-1658">
              {plan.isPopular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F1B530] text-white px-6 py-2 rounded-full font-['Inter'] font-semibold text-sm" data-id="element-1659">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-1660">
                <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-1661">
                  {plan.name}
                </h3>
                {!plan.isCustom ? <>
                    <div className="mb-3" data-id="element-1662">
                      <span className="font-['Poppins'] font-bold text-5xl text-[#1A1A1A]" data-id="element-1663">
                        {plan.price}
                      </span>
                      <span className="text-[#6B6B6B] font-['Inter'] ml-2 text-sm" data-id="element-1664">
                        plus GST/month
                      </span>
                    </div>
                    <p className="text-[#6B6B6B] font-['Inter'] text-sm mb-2 font-light" data-id="element-1665">
                      Up to {plan.calls} • {plan.minutes} free minutes
                    </p>
                  </> : <div className="mb-3" data-id="element-1666">
                    <span className="font-['Poppins'] font-bold text-4xl text-[#1A1A1A]" data-id="element-1667">
                      Custom Pricing
                    </span>
                  </div>}
                <p className="text-[#6B6B6B] font-['Inter'] text-sm italic font-light" data-id="element-1668">
                  {plan.target}
                </p>
              </div>

              <div className="mb-10 flex-grow" data-id="element-1669">
                <ul className="space-y-4" data-id="element-1670">
                  {plan.inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-1671">
                      <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-1672" />
                      <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-1673">
                        {inclusion}
                      </span>
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto" data-id="element-1674">
                <Button className="w-full" size="lg" data-id="element-1675">
                  {plan.ctaText}
                </Button>

                {plan.ctaLink && <a href="#" className="block text-center mt-5 text-[#6B6B6B] font-['Inter'] text-sm hover:text-[#F1B530] transition-colors duration-300" data-id="element-1676">
                    {plan.ctaLink}
                  </a>}
              </div>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-1677">
          <div className="bg-white rounded-2xl p-10 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full shadow-sm hover:shadow-md" data-id="element-1678">
            <div className="mb-8" data-id="element-1679">
              <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-1680">
                {plans[6].name}
              </h3>
              <div className="mb-3" data-id="element-1681">
                <span className="font-['Poppins'] font-bold text-4xl text-[#1A1A1A]" data-id="element-1682">
                  Custom Pricing
                </span>
              </div>
              <p className="text-[#6B6B6B] font-['Inter'] text-sm italic font-light" data-id="element-1683">
                {plans[6].target}
              </p>
            </div>

            <div className="mb-10 flex-grow" data-id="element-1684">
              <ul className="space-y-4" data-id="element-1685">
                {plans[6].inclusions.map((inclusion, idx) => <li key={idx} className="flex items-start" data-id="element-1686">
                    <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-1687" />
                    <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-1688">
                      {inclusion}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="mt-auto" data-id="element-1689">
              <Button className="w-full" size="lg" data-id="element-1690">
                {plans[6].ctaText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function TestimonialsLight() {
  const testimonials = [{
    quote: "This AI answering service has transformed how we handle customer calls. We've seen a 40% increase in captured leads since implementing it.",
    author: 'Sarah Mitchell',
    role: 'CEO, TechStart Solutions',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80',
    rating: 5
  }, {
    quote: 'The 24/7 coverage means we never miss an opportunity. Our customers love the instant response, and so do we.',
    author: 'James Chen',
    role: 'Operations Director, GrowthCo',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80',
    rating: 5
  }, {
    quote: "Setup was incredibly easy, and the AI sounds so natural. It's like having a professional receptionist without the overhead costs.",
    author: 'Emma Thompson',
    role: 'Founder, Bright Ideas Agency',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80',
    rating: 5
  }];
  return <section className="w-full bg-white py-28 md:py-36" data-id="element-1691">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1692">
        <div className="text-center mb-20" data-id="element-1693">
          <h2 className="font-['Poppins'] font-bold text-5xl md:text-6xl text-[#1A1A1A] mb-6" data-id="element-1694">
            Trusted by Growing Businesses
          </h2>
          <p className="font-['Inter'] text-xl text-[#6B6B6B] font-light" data-id="element-1695">
            See what our customers have to say
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1696">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl p-8 hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-1697">
              <div className="flex gap-1 mb-6" data-id="element-1698">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#F1B530] fill-current" data-id="element-1699" />)}
              </div>

              <QuoteIcon className="w-10 h-10 text-[#F1B530]/20 mb-4" data-id="element-1700" />

              <p className="font-['Inter'] text-[#1A1A1A] mb-8 leading-relaxed font-light" data-id="element-1701">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-1702">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-[#F1B530]/20" data-id="element-1703" />
                <div data-id="element-1704">
                  <div className="font-['Inter'] font-semibold text-[#1A1A1A]" data-id="element-1705">
                    {testimonial.author}
                  </div>
                  <div className="font-['Inter'] text-sm text-[#6B6B6B]" data-id="element-1706">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
function AddOnsLight() {
  const addOns = [{
    icon: PhoneForwardedIcon,
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80',
    name: 'Live Transfer',
    price: 'AUD $99',
    setup: 'one-time setup',
    features: ['Instant Escalation for Time Sensitive Opportunities', 'Transfers With Full Caller Context', 'Smart Routing Based on Your Real Business Rules']
  }, {
    icon: MessageCircleIcon,
    image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=800&q=80',
    name: 'FAQ Handling',
    price: 'AUD $299',
    setup: 'one-time fee',
    features: ['Turn AI agent into trained front-line knowledge assistant', 'Fenced responses using only approved information', 'Clear brand-safe responses', 'Faster resolution & reduced message volume']
  }, {
    icon: CalendarCheckIcon,
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&q=80',
    name: 'Appointment Booking',
    price: 'AUD $399',
    setup: 'one-time setup',
    features: ['Real-time calendar syncing (Google, Outlook, etc.)', 'Automated booking and confirmation', 'Custom booking rules', 'Caller notifications and internal alerts']
  }];
  return <section className="w-full bg-[#F5F5F5] py-28 md:py-36" data-id="element-1707">
      <div className="max-w-7xl mx-auto px-8 md:px-12" data-id="element-1708">
        <div className="text-center mb-20" data-id="element-1709">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6 tracking-tight" data-id="element-1710">
            Universal Add-Ons
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-3xl mx-auto font-light" data-id="element-1711">
            Available for all plans to extend your AI answering service
            capabilities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1712">
          {addOns.map((addOn, index) => {
          const Icon = addOn.icon;
          return <div key={index} className="bg-white rounded-2xl overflow-hidden border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 hover:-translate-y-1 shadow-sm hover:shadow-md" data-id="element-1713">
                <div className="relative h-48 overflow-hidden" data-id="element-1714">
                  <img src={addOn.image} alt={addOn.name} className="w-full h-full object-cover opacity-80" data-id="element-1715" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white" data-id="element-1716"></div>
                  <div className="absolute bottom-4 left-4 w-14 h-14 bg-[#F1B530]/90 backdrop-blur-sm rounded-xl flex items-center justify-center border border-[#F1B530]" data-id="element-1717">
                    <Icon className="w-7 h-7 text-white" data-id="element-1718" />
                  </div>
                </div>

                <div className="p-10" data-id="element-1719">
                  <h3 className="font-['Poppins'] font-bold text-2xl text-[#1A1A1A] mb-3" data-id="element-1720">
                    {addOn.name}
                  </h3>

                  <div className="mb-8" data-id="element-1721">
                    <span className="font-['Poppins'] font-semibold text-2xl text-[#F1B530]" data-id="element-1722">
                      {addOn.price}
                    </span>
                    <span className="text-[#6B6B6B] font-['Inter'] text-sm ml-2" data-id="element-1723">
                      {addOn.setup}
                    </span>
                  </div>

                  <ul className="space-y-4" data-id="element-1724">
                    {addOn.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-1725">
                        <span className="text-[#F1B530] mr-3 flex-shrink-0 text-lg" data-id="element-1726">
                          •
                        </span>
                        <span className="font-['Inter'] text-[#1A1A1A] text-sm leading-relaxed font-light" data-id="element-1727">
                          {feature}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
function AdvancedAutomationLight() {
  const capabilities = [{
    icon: WorkflowIcon,
    text: 'Route leads intelligently'
  }, {
    icon: ZapIcon,
    text: 'Trigger automated workflows'
  }, {
    icon: DatabaseIcon,
    text: 'Sync directly into CRMs'
  }, {
    icon: BrainCircuitIcon,
    text: 'Collect structured information'
  }];
  return <section className="w-full bg-white py-28 md:py-36 relative overflow-hidden" data-id="element-1728">
      <div className="absolute inset-0" data-id="element-1729">
        <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=1920&q=80" alt="" className="w-full h-full object-cover opacity-5" data-id="element-1730" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/90 to-white" data-id="element-1731"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 md:px-12 text-center relative z-10" data-id="element-1732">
        <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl lg:text-6xl mb-6 tracking-tight text-[#1A1A1A]" data-id="element-1733">
          AI Automation Customisation Advanced
        </h2>
        <p className="font-['Inter'] font-light text-xl md:text-2xl text-[#6B6B6B] mb-10" data-id="element-1734">
          Automate More Than Calls. Automate Your Entire Frontline.
        </p>

        <p className="font-['Inter'] text-lg text-[#6B6B6B] max-w-4xl mx-auto mb-16 leading-relaxed font-light" data-id="element-1735">
          For businesses handling 500+ calls per month, unlock advanced
          capabilities that transform your AI answering service into a complete
          frontline automation platform.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-1736">
          {capabilities.map((capability, index) => {
          const Icon = capability.icon;
          return <div key={index} className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-[#E5E5E5] hover:border-[#F1B530]/50 transition-all duration-300 shadow-sm hover:shadow-md h-full flex flex-col items-center justify-center min-h-[180px]" data-id="element-1737">
                <Icon className="w-10 h-10 text-[#F1B530] mx-auto mb-5" data-id="element-1738" />
                <p className="font-['Inter'] text-[#1A1A1A] font-light text-center" data-id="element-1739">
                  {capability.text}
                </p>
              </div>;
        })}
        </div>

        <div className="mb-16 relative" data-id="element-1740">
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 border border-[#E5E5E5] max-w-4xl mx-auto shadow-lg" data-id="element-1741">
            <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80" alt="Automation workflow visualization" className="w-full h-64 object-cover rounded-xl opacity-90" data-id="element-1742" />
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1743">
              <div className="bg-[#F1B530]/10 backdrop-blur-md border border-[#F1B530]/30 rounded-xl px-8 py-4" data-id="element-1744">
                <p className="font-['Inter'] text-[#F1B530] font-semibold text-lg" data-id="element-1745">
                  Complete Workflow Automation
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-10 border border-[#E5E5E5] mb-12 max-w-3xl mx-auto shadow-sm" data-id="element-1746">
          <h3 className="font-['Inter'] font-semibold text-xl mb-6 text-[#1A1A1A]" data-id="element-1747">
            Extended Capabilities Include:
          </h3>
          <ul className="font-['Inter'] text-[#6B6B6B] space-y-3 text-left max-w-2xl mx-auto font-light" data-id="element-1748">
            <li data-id="element-1749">• Support multi-step decision trees</li>
            <li data-id="element-1750">• Extended conversational capabilities</li>
            <li data-id="element-1751">• Custom API integrations</li>
            <li data-id="element-1752">• Advanced data collection and processing</li>
            <li data-id="element-1753">• Bespoke workflow automation</li>
          </ul>
        </div>

        <Button size="lg" data-id="element-1754">Contact Sales</Button>
      </div>
    </section>;
}
function FAQLight() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How does the AI answering service work?',
    answer: 'Our AI receptionist answers calls 24/7, captures caller information, handles FAQs, and can even book appointments. It integrates seamlessly with your existing systems and can be customized to match your business needs.'
  }, {
    question: 'Can I customize the greeting and responses?',
    answer: 'Absolutely! You can fully customize your company greeting, upload FAQs, set routing rules, and define your brand voice. The AI learns from your business to provide accurate, on-brand responses.'
  }, {
    question: "What happens if the AI can't handle a call?",
    answer: 'The AI can transfer calls to your team with full context when needed. You set the rules for when calls should be escalated, ensuring important matters always reach the right person.'
  }, {
    question: 'How quickly can I get started?',
    answer: "Setup takes less than 5 minutes. Simply sign up, customize your greeting and settings, forward your number, and you're live. We provide step-by-step guidance throughout the process."
  }, {
    question: 'Is there a contract or commitment?',
    answer: 'No long-term contracts required. Start with our 7-day free trial, then choose a monthly plan that fits your needs. You can upgrade, downgrade, or cancel anytime.'
  }];
  return <section className="w-full bg-[#F5F5F5] py-28 md:py-36" data-id="element-1755">
      <div className="max-w-4xl mx-auto px-8 md:px-12" data-id="element-1756">
        <div className="text-center mb-16" data-id="element-1757">
          <h2 className="font-['Poppins'] font-bold text-4xl md:text-5xl text-[#1A1A1A] mb-6" data-id="element-1758">
            Frequently Asked Questions
          </h2>
          <p className="font-['Inter'] text-lg text-[#6B6B6B] font-light" data-id="element-1759">
            Everything you need to know about our AI answering service
          </p>
        </div>

        <div className="space-y-4" data-id="element-1760">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#E5E5E5] rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#F1B530]/50 shadow-sm hover:shadow-md" data-id="element-1761">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left" data-id="element-1762">
                <span className="font-['Inter'] font-semibold text-xl text-[#1A1A1A] pr-8" data-id="element-1763">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#F1B530] flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-1764" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-1765">
                <div className="px-8 pb-6" data-id="element-1766">
                  <p className="font-['Inter'] text-[#6B6B6B] leading-relaxed font-light" data-id="element-1767">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function LandingPageLight() {
  return <div className="w-full min-h-screen bg-white" data-id="element-1768">
      <HeroLight data-id="element-1769" />
      <ValuePropositionLight data-id="element-1770" />
      <FeatureShowcaseLight data-id="element-1771" />
      <IndustryBenefitsLight data-id="element-1772" />
      <PricingPlansLight data-id="element-1773" />
      <TestimonialsLight data-id="element-1774" />
      <AddOnsLight data-id="element-1775" />
      <AdvancedAutomationLight data-id="element-1776" />
      <FAQLight data-id="element-1777" />
    </div>;
}